module.exports = __webpack_public_path__ + "img/main@2x.7d50ca5.png";